/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Items_FoundInputs */

const en_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found`)
};

const es_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron artículos`)
};

const fr_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun article trouvé`)
};

const de_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Artikel gefunden`)
};

const ja_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムが見つかりません`)
};

const zh_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到商品`)
};

const ar_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على عناصر`)
};

const id_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada item ditemukan`)
};

const it_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun articolo trovato`)
};

const ru_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ничего не найдено`)
};

const pt_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item encontrado`)
};

const ko_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`항목을 찾을 수 없습니다`)
};

/**
* | output |
* | --- |
* | "No items found" |
*
* @param {No_Items_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_items_found = /** @type {((inputs?: No_Items_FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Items_FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_items_found(inputs)
	if (locale === "es") return es_no_items_found(inputs)
	if (locale === "fr") return fr_no_items_found(inputs)
	if (locale === "de") return de_no_items_found(inputs)
	if (locale === "ja") return ja_no_items_found(inputs)
	if (locale === "zh") return zh_no_items_found(inputs)
	if (locale === "ar") return ar_no_items_found(inputs)
	if (locale === "id") return id_no_items_found(inputs)
	if (locale === "it") return it_no_items_found(inputs)
	if (locale === "ru") return ru_no_items_found(inputs)
	if (locale === "pt") return pt_no_items_found(inputs)
	return ko_no_items_found(inputs)
});